// Description: JS Debug functions.

/**
 * Enable debug messages when running on localhost or rocktime.net.
 */
const debugMessagesEnabled = window.location.href.includes('localhost') || window.location.href.includes('rocktime.net');

/**
 * Logs a debug message to the console.
 * @param {string} message - The message to log.
 */
function debug(message) {
    if (debugMessagesEnabled) {
        console.log(message);
    }
}

/**
 * Logs an error message to the console.
 * @param {string} message - The message to log.
 */
function error(message) {
    if (debugMessagesEnabled) {
        console.error(message);
    }
}
